if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        // === No Refund / Final Sale policy consent wiring ===
        this.policyConsentWrap = this.querySelector('[data-policy-consent]');
        if (this.policyConsentWrap) {
          this.policyConsentInput = this.policyConsentWrap.querySelector('input[type="checkbox"]');
          this.policyConsentError = this.policyConsentWrap.querySelector('[data-policy-consent-error]');

          // Initial state: if not checked, disable submit for better UX
          if (this.policyConsentInput && !this.policyConsentInput.checked) {
            this.submitButton.setAttribute('disabled', 'disabled');
            this.submitButton.classList.add('is-disabled');
          }

          // Toggle button enabled/disabled as the checkbox changes
          if (this.policyConsentInput) {
            this.policyConsentInput.addEventListener('change', () => {
              if (this.policyConsentInput.checked) {
                this.submitButton.removeAttribute('disabled');
                this.submitButton.classList.remove('is-disabled');
                this.setPolicyError('');
              } else {
                this.submitButton.setAttribute('disabled', 'disabled');
                this.submitButton.classList.add('is-disabled');
              }
            });
          }

          // Helper to show/hide error styles/message
          this.setPolicyError = (msg) => {
            if (!this.policyConsentWrap || !this.policyConsentError) return;
            if (msg) {
              this.policyConsentWrap.classList.add('has-error');
              this.policyConsentError.textContent = msg;
            } else {
              this.policyConsentWrap.classList.remove('has-error');
              this.policyConsentError.textContent = '';
            }
          };

          // Validator for submit
          this.validatePolicyConsent = () => {
            if (!this.policyConsentWrap || !this.policyConsentInput) return true; // No UI -> pass
            if (this.policyConsentInput.checked) {
              this.setPolicyError('');
              return true;
            }
            this.setPolicyError('You must agree to the No Refund / Final Sale policy.');
            try {
              this.policyConsentInput.focus({ preventScroll: false });
            } catch (e) {
              this.policyConsentInput.focus();
            }
            return false;
          };

          this.addEventListener('click', (ev) => {
            var trigger = ev.target && ev.target.closest && ev.target.closest('[data-open-policy-details]');
            if (!trigger) return;
            ev.preventDefault();

            var detailsEl =
              this.querySelector('#policy-details-' + this.dataset.sectionId) || this.querySelector('.policy-details');

            if (detailsEl) {
              // Toggle open/close
              var willOpen = !detailsEl.open;
              detailsEl.open = willOpen;
              // Only scroll when opening
              if (willOpen) {
                try {
                  detailsEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
                } catch (e) {}
              }
              var summary = detailsEl.querySelector('summary');
              if (summary) summary.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

              var openText = trigger.getAttribute('data-open-text') || 'View policy';
              var closeText = trigger.getAttribute('data-close-text') || 'Hide policy';
              trigger.textContent = willOpen ? closeText : openText;
              trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

              var detailsSyncEl =
                this.querySelector('#policy-details-' + this.dataset.sectionId) ||
                this.querySelector('.policy-details');
              if (detailsSyncEl) {
                detailsSyncEl.addEventListener('toggle', () => {
                  var link = this.policyConsentWrap
                    ? this.policyConsentWrap.querySelector('[data-open-policy-details]')
                    : null;
                  if (!link) return;
                  var openText = link.getAttribute('data-open-text') || 'View policy';
                  var closeText = link.getAttribute('data-close-text') || 'Hide policy';
                  link.textContent = detailsSyncEl.open ? closeText : openText;
                  link.setAttribute('aria-expanded', detailsSyncEl.open ? 'true' : 'false');
                });
              }
            }
          });
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        // Block submission if policy consent not given (when UI exists)
        if (this.validatePolicyConsent && !this.validatePolicyConsent()) {
          return;
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
